import { Link } from '@tanstack/react-router'
import { Inbox } from 'lucide-react'
import { useRoomRequests } from '~/entities/room-request/model/use-room-requests'
import * as m from '~/paraglide/messages'
import { Badge } from '~/shared/ui/badge'
import { Button } from '~/shared/ui/button'

/** Opens the event's request list, with the number of requests still waiting for an answer. */
export function EventRequestsButton({
  businessId,
  eventId,
}: {
  businessId: string
  eventId: string
}) {
  const requests = useRoomRequests(businessId, eventId, 'pending')
  const open = requests.data?.counts.pending ?? 0

  return (
    <Button asChild variant="outline">
      <Link to="/dashboard/events/$eventId/requests" params={{ eventId }}>
        <Inbox className="mr-2 h-4 w-4" />
        {m.eventRequests()}
        {open > 0 ? (
          <Badge className="ml-2" aria-label={m.openRequestsLabel({ count: String(open) })}>
            {open}
          </Badge>
        ) : null}
      </Link>
    </Button>
  )
}
